module.exports = __webpack_public_path__ + "static/media/099-save.24701ca6.svg";